var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-slide swiper-slide"},[(_vm.image !== '')?_c('div',{staticClass:"card-slide__header",style:(`background-image: url(${_vm.image})`)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-slide__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }